import { render, staticRenderFns } from "./DigitalClinicsSingleClinician.vue?vue&type=template&id=a4f26b66"
import script from "./DigitalClinicsSingleClinician.vue?vue&type=script&lang=js"
export * from "./DigitalClinicsSingleClinician.vue?vue&type=script&lang=js"
import style0 from "./DigitalClinicsSingleClinician.vue?vue&type=style&index=0&id=a4f26b66&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports